module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_01A.3b90e4e9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_01A.mp3
// module id = 112
// module chunks = 0